import type { LensResponse, LensSharing } from '~/types/leLens';

export function ownsLensDraft(detail: LensResponse | undefined, email: string | undefined): boolean {
  const editor = detail?.publication?.editorEmail;
  return Boolean(email && editor && editor.toLowerCase() === email.toLowerCase());
}

export function lensForPublication(detail: LensResponse | undefined, draftShown: boolean) {
  if (!detail) return undefined;
  if (!detail.publication || draftShown || detail.publication.publishedVersion === null) return detail.lens;
  const version = detail.publication.publishedVersion;
  if (detail.publishedLens?.version === version) return detail.publishedLens;
  return detail.lens.version === version ? detail.lens : undefined;
}

export function publicationAudience(sharing: LensSharing | undefined): string {
  if (!sharing) return 'the people who already have access';
  if (sharing.audience === 'company') return 'everyone at Luxury Escapes';
  if (sharing.linkAccess?.enabled) return 'signed-in employees with the link and existing shared recipients';
  if (sharing.audience === 'reporting-admins') return 'the owner and reporting administrators';
  if (sharing.home.kind === 'space') return `${sharing.home.spaceName} and anyone already shared on this report`;
  return sharing.recipientCount ? 'the owner and existing shared recipients' : 'only the owner';
}
